import React from 'react'
import styles from './Popup.module.scss'
import {useHotkeys} from 'react-hotkeys-hook'
// eslint-disable-next-line no-restricted-imports
import {getLobbyImagePath} from '../../../../../code/client/shared/scripts/ui_utils/Utils'
import {LobbyImage} from '@colonist/types'
import {TranslationObject} from '@colonist/i18n'
import {T} from '../T'

interface PopupProps {
    title?: TranslationObject
    isOpen: boolean
    onClose: () => void
    children: React.ReactNode
}

export function Popup({
    title,
    isOpen,
    onClose,
    children,
}: PopupProps) {
    useHotkeys('esc', () => {
        if(isOpen) onClose()
    }, [isOpen, onClose])

    if(!isOpen) return null

    return (
        <div
            className={styles.overlay}
            onClick={onClose}
            aria-modal="true"
            role="dialog">
            <div
                className={styles.popup}
                onClick={(e) => e.stopPropagation()}>
                <div className={styles.popupHeader}>
                    <div className={styles.popupHeaderTitle}>
                        {title && <T id={title} />}
                    </div>
                    <button
                        className={styles.popupHeaderCloseButton}
                        onClick={onClose}>
                        <img src={getLobbyImagePath(LobbyImage.XMark)} />
                    </button>
                </div>
                {children}
            </div>
        </div>
    )
}
